import { Fragment, ReactNode } from 'react';

import { IStepProps, Step } from '@/components/Profile/LoyaltyProgram/Step/Step.tsx';
import { Button } from '@/components/shared/Button';
import { Divider } from '@/components/shared/Divider/Divider.tsx';

import cn from './styles.module.sass';

interface IWayToEarnBlockProps {
    wayNumber: number;
    wayDescription: string;
    imgSrc: string;
    steps: IStepProps[];
    btnText: ReactNode;
    onClick?: VoidFunction;
}

export const WayToEarnBlock = ({
    wayNumber,
    wayDescription,
    imgSrc,
    steps,
    btnText,
    onClick,
}: IWayToEarnBlockProps) => {
    return (
        <div className={cn.wayToEarnBlock}>
            <div className={cn.wayToEarnHead}>
                <p>Способ {wayNumber}:</p>
                <h3>{wayDescription}</h3>
            </div>
            <div className={cn.imageWrapper}>
                <img src={imgSrc} alt="" />
            </div>
            <div className={cn.stepsList}>
                {steps.map((step, index, arr) => (
                    <Fragment key={step.stepNumber}>
                        <Step stepNumber={step.stepNumber} description={step.description} />
                        {index !== arr.length - 1 && <Divider />}
                    </Fragment>
                ))}
            </div>
            <Button onClick={onClick} className={cn.button}>
                {btnText}
            </Button>
        </div>
    );
};
